<template>
  <vs-row>
    <vs-tooltip
      :text="badge.title"
      position="bottom"
      delay="140ms"
      v-for="badge in badges"
      :key="badge.identifier"
    >
      <img
        v-bind:class="{ notTaken: !badge.isEarned }"
        class="mr-2"
        width="55px"
        :src="badge.imageUrl"
      />
    </vs-tooltip>
  </vs-row>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";

export default {
  components: {},
  props: ["badges"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },

  methods: {},
  async mounted() {},
};
</script>

<style scoped lang="scss">
.notTaken {
  filter: grayscale(100%);
}
</style>